// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__1UVhn","form":"Form_form__2X2Tq"};